import { makeStyles, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
	root: {
		'& .logo-icon': {
			width: 32,
			height: 32,
			transition: theme.transitions.create(['width', 'height'], {
				duration: theme.transitions.duration.shortest,
				easing: theme.transitions.easing.easeInOut
			})
		},
		'& .free': {
			width: 64,
			height: 64
		},
		'& .logo-name': {
			textDecoration: 'none !important'
		}
	},
	reactBadge: {
		backgroundColor: '#121212',
		color: '#61DAFB'
	}
}));

function Logo() {
	const navbar = useSelector(({ fuse }) => fuse.settings.current.layout.config.navbar);
	const classes = useStyles();
	const theme = useTheme();
	const mdDown = useMediaQuery(theme.breakpoints.down('md'));
	const { t } = useTranslation('fuse-layout');

	return (
		<div className={clsx(classes.root, 'flex')}>
			{navbar.position === 'top' && !mdDown && (
				<a href="https://saiwa.ai/">
					<img className="logo-icon free" src={`${process.env.PUBLIC_URL}/assets/images/logos/saiwa.svg`} alt="logo" />
				</a>
			)}
			{(navbar.position === 'left' || (navbar.position === 'top' && mdDown)) && (
				<>
					<a href="https://saiwa.ai/">
						<img className="logo-icon" src={`${process.env.PUBLIC_URL}/assets/images/logos/saiwa-w.svg`} alt="logo" />
					</a>
					<a href="https://saiwa.ai/" className="logo-name">
						<Typography className="text-15 mx-8 font-bold logo-text text-yellow-50" color="inherit">
							{t('navbar.logoName')}
						</Typography>
					</a>
				</>
			)}
		</div>
	);
}

export default Logo;
